import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/i18n";
import { openComparisonChat } from "../../services/Comparisons";

/** Opens (creating it the first time) the person's chat about a comparison */
const ContinueInChatButton: React.FC<{
  comparisonId: string;
  variant?: "outline" | "default" | "ghost";
  size?: "sm" | "default";
}> = ({ comparisonId, variant = "outline", size = "default" }) => {
  const { t } = useI18n();
  const c = t.comparisons;
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  const open = async () => {
    setBusy(true);
    try {
      const res = await openComparisonChat(comparisonId);
      if (res.success && res.data) navigate(`/qagent/${res.data.chatId}`);
      else toast.error(c.chatFailed);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button variant={variant} size={size} disabled={busy} onClick={() => void open()}>
      {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <MessageSquare className="mr-2 h-4 w-4" />}
      {busy ? c.openingChat : c.continueInChat}
    </Button>
  );
};

export default ContinueInChatButton;
